import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ImgHeaderSubheader from "../../../components/SignUpLoginForgot/ImgHeaderSubheader";
import LoginBackButton from "../../../components/SignUpLoginForgot/LoginBackButton";
import PowerGoAndSubheader from "../../../components/SignUpLoginForgot/PowerGoAndSubheader";
import LoginInputfield from "../../../components/SignUpLoginForgot/LoginInputfield";
import Button from "../../../components/Button";
import { Colors, Text } from "../../../config";
import {
  LoginLayout,
  WidthWrapper,
  FlexWithGap,
  LoginInnerWrapperOther,
} from "../../../components/SignUpLoginForgot/LoginStyledComponents";
import ErrorModal from "../../../components/ErrorSuccessModal/ErrorModal";
import { forgotPin } from "../../../services/userServices";
import { useLoaderContext } from "../../../contexts/loaderContext";

const forgotImage = require("../../../assets/images/img_forgotpassword.png");
const sendIcon = require("../../../assets/images/Send.png");

const ForgotPin = () => {
  const navigate = useNavigate();
  const [employeeID, setEmployeeID] = useState("");
  const [employeeIdError, setEmployeeIdError] = useState("");
  const [backendErrorMsg, setBackendErrorMsg] = useState(false);
  const { setLoader } = useLoaderContext();

  const handleBackClick = () => {
    navigate("/auth/login/employee");
  };

  const handleChange = (e) => {
    setEmployeeID(e.target.value);
    setEmployeeIdError("");
  };

  const handleSend = () => {
    if (employeeID === "") setEmployeeIdError("Please enter employee ID");
    else {
      const forgotPinData = {
        empId: employeeID,
      };
      postForgotPinData(forgotPinData);
    }
  };

  const postForgotPinData = async (forgotPinData) => {
    console.log(forgotPinData);
    setLoader(true);
    try {
      const response = await forgotPin(forgotPinData);
      console.log(response);
      if (response.status === 200) {
        setLoader(false);
        let responseData = response.data.data;
        localStorage.setItem("userId", responseData.userId);
        localStorage.setItem("phone", responseData.phone);
        navigate("/auth/forgot/otp");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      setBackendErrorMsg(error.message);
    }
  };

  const closeErrorModal = () => {
    setBackendErrorMsg(false);
  };

  return (
    <>
      <LoginBackButton onClick={handleBackClick} />
      <LoginLayout>
        <LoginInnerWrapperOther>
          <PowerGoAndSubheader />
          <WidthWrapper maxWidth="42rem">
            <ImgHeaderSubheader
              imgSrc={forgotImage}
              header={Text.forgotPinQ}
              subheader={Text.dontWorryEnterEmployeeId}
            />
          </WidthWrapper>
          <WidthWrapper maxWidth="22.5rem">
            <FlexWithGap gap="2rem">
              <LoginInputfield
                label={Text.employeeID}
                placeholder={Text.enterEmployeeID}
                value={employeeID}
                onChange={handleChange}
                errorText={employeeIdError}
              />
              <Button
                label={Text.send}
                onClick={handleSend}
                rightImgSrc={sendIcon}
                fontColor={Colors.white}
                fontSize="1.375rem"
                fontWeight="700"
                bgColor={Colors.brandTwo}
                topBottomPadding="0.75rem"
                labelImgGap="0.5rem"
              />
            </FlexWithGap>
          </WidthWrapper>
        </LoginInnerWrapperOther>
      </LoginLayout>
      {backendErrorMsg && (
        <ErrorModal
          subheaderText={backendErrorMsg}
          setClose={closeErrorModal}
          onButtonClick={closeErrorModal}
        />
      )}
    </>
  );
};

export default ForgotPin;
